import { render } from "./LeaveApply.vue?vue&type=template&id=2c83ea74"
import script from "./LeaveApply.vue?vue&type=script&lang=js"
export * from "./LeaveApply.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__